import React from 'react';

export const ScriptContent = () => (
  <>
    <p>Need to confirm if paying by DD the following:</p>
    <ul>
      <li>Does the bank account provided require only one signature?</li>
      <li>Is the bank account provided yours and will it accept Direct Debits?</li>
      <li>By paying by DD you are agreeing to keep up payments and failure to meet the DD may result in your policy being cancelled and any claims not being paid</li>
    </ul>
  </>
);
